import { type DiscountBadge } from './types';

function hasVisibleText(value: string | undefined): boolean {
    return typeof value === 'string' && Boolean(value.trim());
}

function hasDiscountCodeCampaignBadge(
    discountBadge: DiscountBadge | undefined,
    hasStrikePrice = false,
): boolean {
    return (
        hasVisibleText(discountBadge?.descriptionLabel) &&
        hasVisibleText(discountBadge?.description) &&
        !hasStrikePrice
    );
}

export { hasDiscountCodeCampaignBadge };
